import { cx } from "@suse-o11y/class-variance";
import React from "react";

import { Truncated } from "~/components/truncated";

export interface WidgetLayoutProps {
	className?: string;
	title?: string;
	description?: string;
	actions?: React.ReactNode;
	children: React.ReactNode;
}

export const WidgetLayout = React.forwardRef<React.ComponentRef<"div">, WidgetLayoutProps>(
	({ className, title, description, actions, children }, ref) => (
		<div className={cx("flex flex-col gap-3", className)} ref={ref}>
			{title != null && (
				<div className="flex flex-row justify-between gap-6 font-normal text-13/5 text-grey-800">
					<Truncated tooltip={description ? `${title} - ${description}` : title}>{title}</Truncated>

					{actions}
				</div>
			)}

			{children}
		</div>
	),
);
